module.exports = __webpack_public_path__ + "static/willpower-057363a1d578a83b0ff88e7990227f2a.jpg";